/**
 * Avatar welcome copy with optional in-store proximity context.
 */

export const extractFirstName = (customerName) => {
  const name = String(customerName ?? "").trim();
  if (!name) return "there";

  const firstToken = name.split(/\s+/)[0] || name;
  return firstToken.split(".")[0] || "there";
};

/**
 * @param {string} customerName
 * @param {{ name?: string } | null} nearbyStore
 */
export const buildAvatarWelcomeMessage = (customerName, nearbyStore = null) => {
  const firstName = extractFirstName(customerName);

  if (nearbyStore?.name) {
    return `Welcome to ${nearbyStore.name}, ${firstName}! You're at our store location. How can I help you today?`;
  }

  return `Welcome back ${firstName}, I'm here to assist you. Let me know how can I help you today.`;
};
